<template>
    <div class="row">
        <div class="col-sm-7">
            <strong><span class="text-muted small">звонок</span>
                <span>
                <PhoneIncomingIcon v-if="item.data.direction === 'IN' && item.data.status !== 'NO_ANSWER'" class="text-success"/>
                <PhoneOutgoingIcon v-if="item.data.direction === 'OUT'" class="text-primary"/>
                <PhoneMissedIcon v-if="item.data.direction === 'IN' && item.data.status === 'NO_ANSWER'" class="text-danger"/>
            </span>
                <span v-if="item.data.user" class="badge badge-primary">{{item.data.user.name}}</span>
                <span class="small text-muted">{{phoneView}}</span>
            </strong>
        </div>
        <div class="col-sm-5">
            <div class="float-sm-right request-action-item-right pr-2">
                <span class="mr-1" v-if="item.data.direction === 'OUT' && item.data.status === 'ANSWERED' && item.data.duration > 0">
                    <el-tooltip v-if="item.data.heard_human" class="item" effect="dark" content="Услышали человека" placement="top">
                        <i class="fas fa-user text-success"></i>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" content="Человека НЕ услышали" placement="top">
                        <i class="fas fa-user-slash text-warning"></i>
                    </el-tooltip>
                </span>
                <RequestCallStatusBadge :call="item.data"/>
                <span class="small">{{item.data.called_at}}</span>
            </div>
        </div>
        <div class="col-12">
            <p>
                <!--            <audio controls v-if="item.data.duration && item.data.record" :src="record_url" />-->
                <VuePlyr ref="plyr_player" :options="playerOptions" v-if="item.data.duration && item.data.record">
                    <audio :src="record_url" preload="none"/>
                </VuePlyr>
            </p>
        </div>
    </div>
</template>

<script>
    import {PhoneIncomingIcon, PhoneOutgoingIcon, PhoneMissedIcon} from "vue-feather-icons";
    import RequestCallStatusBadge from "../RequestCallStatusBadge";
    import VuePlyr from "vue-plyr";
    import plyrMenuPortalMixin from "../../utils/plyrMenuPortalMixin";

    export default {
        name: "RequestHistoryActionCall",
        components: {VuePlyr, RequestCallStatusBadge, PhoneIncomingIcon, PhoneOutgoingIcon, PhoneMissedIcon},
        mixins: [plyrMenuPortalMixin],
        props: ['item'],
        data: () => ({

        }),
        computed: {
            record_url() {
                if (!this.item.data.record) return '';
                return '/storage' + this.item.data.record.file_path;
            },
            playerOptions () {
                return {
                    controls: ['play-large', 'play', 'progress', 'current-time', 'download', 'settings'],
                    settings: ['speed'],
                    duration: this.item.data.duration,
                };
            },
            phoneView() {
                let phone = this.item.data.direction === 'IN' ? this.item.data.src : this.item.data.dst;
                return this.$hasPermission('request.phone.show_full.without_challenge') ? phone : this.$hidePartPhone(phone);
            }
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
